import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';

import { AttendanceRoutingModule } from './attendance.routing';
import { ValidationService } from '../form-validation/validation.service';
import { AttendanceComponent } from './attendance.component';
import { AttendanceService } from './attendance.service';

@NgModule({ declarations: [
        AttendanceComponent
    ], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        AttendanceRoutingModule], providers: [ValidationService, AttendanceService, provideHttpClient(withInterceptorsFromDi())] })

export class AttendanceModule {}
